"use strict";
//var _ = require('lodash');
var util = require('./myutil.js');
var ID_CACHE = {};
var ID_INVERSE_CACHE = {};
var number = 1;
var numbers = {
    toy: 1,
    component: 1,
    link: 1,
    feature: 1,
    transform: 1
};
function getId(id, type) {
    var k = id;
    if (ID_INVERSE_CACHE[k]) {
        return ID_INVERSE_CACHE[k];
    }
    if (!ID_CACHE[k]) {
        //ID_CACHE[k] = numbers[type];
        ID_CACHE[k] = ''+number;
        ID_INVERSE_CACHE[ID_CACHE[k]] = ID_CACHE[k];
        number++;
        //numbers[type]++;
    }
    return ID_CACHE[k];
}
function convertComponentIds(components) {
    components.forEach(function (c) {
        c.id = getId(c.id, 'component');
        if (c.fid) {
            c.fid = getId(c.fid, 'feature');
        }
        if (c.tid) {
            c.tid = getId(c.tid, 'transform');
        }
    });
}
function convertLinkIds(links) {
    links.forEach(function (l) {
        l.id = getId(l.id, 'link');
        l.source = getId(l.source, 'component');
        l.target = getId(l.target, 'component');
        if (l.meta) {
            if (l.meta.cid) {
                l.meta.cid = getId(l.meta.cid, 'component');
            }
        }
    });
}
function convertTransformIds(transforms) {
    transforms.forEach(function (t) {
        t.id = getId(t.id, 'transform');
        if (t.cid) {
            t.cid = getId(t.cid, 'component');
        }
    });
}
function convert(gamedata) {
    var components = [];
    var links = [];
    var transforms = [];
    gamedata.toybox.forEach(function (toy) {
        var toyComponents = [];
        var toyLinks = [];
        var toyTransforms = [toy];
        toy.transforms.forEach(function (t) {
            var transformComponents = [];
            var transformLinks = [];
            var transformTransforms = [];
            util.findAllComponentsFromTransforms(transformComponents, transformLinks, transformTransforms, toy, t);
            toyComponents = toyComponents.concat(transformComponents);
            toyLinks = toyLinks.concat(transformLinks);
            toyTransforms = toyTransforms.concat(transformTransforms);
        });
        components = components.concat(toyComponents);
        links = links.concat(toyLinks);
        transforms = transforms.concat(toyTransforms);
    });
    gamedata.scenes.forEach(function (scene) {
        var sceneComponents = [];
        var sceneLinks = [];
        var sceneTransforms = [];
        scene.transforms.forEach(function (t) {
            var transformComponents = [];
            var transformLinks = [];
            var transformTransforms = [];
            util.findAllComponentsFromTransforms(transformComponents, transformLinks, transformTransforms, scene, t);
            transforms = transforms.concat(transformTransforms);
            sceneComponents = sceneComponents.concat(transformComponents);
            sceneLinks = sceneLinks.concat(transformLinks);
            sceneTransforms = sceneTransforms.concat(transformTransforms);
        });
        components = components.concat(sceneComponents);
        links = links.concat(sceneLinks);
        //console.log('wtf', sceneTransforms.length);
        transforms = transforms.concat(sceneTransforms);
    });
    components = _.uniqBy(components, function (x) { return x.id; });
    links = _.uniqBy(links, function (x) { return x.id; });
    transforms = _.uniqBy(transforms, function (x) { return x.id; });
    //console.log('checking components',components.length);
    convertComponentIds(components);
    //console.log('components', components);
    //console.log('LINKS--------- checking links', links);
    convertLinkIds(links);
    //console.log('links',links);
    //console.log('checking transforms', transforms.length);
    convertTransformIds(transforms);
    gamedata.features.forEach(function (feature) {
        feature.id = getId(feature.id, 'feature');
        convertComponentIds([feature.root].concat(feature.components));
        convertLinkIds(feature.links);
    });
}
module.exports = convert;
